// Vuex
import store from '@/store.js'

import Request from './request'

async function login (data) {
  const response = await Request('post', 'api/authorizations', data)
  if (localStorage.getItem('midAccessToken'))
    localStorage.removeItem('midAccessToken')
  if (response.data && response.data.status.isOK()) {
    store.commit('LOGIN', response.data.access_token)
  }
  return response
}

async function check () {
  // 检查本地accessToken的登录状态
  const response = await Request('get', 'api/authorizations')
  if (response.data && response.data.status.isOK()) {
    store.commit('LOGIN', localStorage.getItem('accessToken'))
  } else {
    store.commit('LOGOUT') // 前端登出
  }
  return response
}

async function logout () {
  store.commit('LOGOUT') // 前端登出
  if (localStorage.getItem('midAccessToken'))
    localStorage.removeItem('midAccessToken')
  return Request('delete', 'api/authorizations/0') // 后端登出（调用cake的delete方法一定要给id参数）
}

async function checkAccessTokenToMid (data) {
  //验证当前登录账户的access_token
  var headers = []
  if (localStorage.getItem('midAccessToken'))
    headers['access-token'] = localStorage.getItem('midAccessToken')
  //验证当前登录账户的access_token
  return Request(
    'post',
    localStorage.getItem('pushMidURL') + 'api/auth/',
    data,
    false,
    headers
  )
}

export default {
  login,
  check,
  logout,
  checkAccessTokenToMid
}
